﻿import { ScrollLock } from '../helpers/scrollLock';
import { EsAppHelper } from '../helpers/esAppHelper';
import { DesignerOverlayModal } from '../designerOverlayModal/designerOverlayModal';
import { TransforToCartOverlayModal } from '../transforToCartOverlayModal/transforToCartOverlayModal';
import {
    IDesignerAppshellPayload, ICreatVariantRespons, ITTCObject, ISmakeArticle, IBasketModalPayload,
    IContext, AddCollectionItemsToCartResponse, ITeamDesignerReporting
} from '../types';
import { IVariant, IBasketItems, IVariantArticles } from '../basketService/article';
import { BasketService } from '../basketService/basketService';
import { LogoCreaterService } from '../logoCreaterService/logoCreaterService';
import { ConfirmationModal } from '../confirmationModal/confirmationModal';
import { NoAvailableSizeModal } from '../noAvailableSizeModal/noAvailableSizeModal';
import { ISmakevailableVariant } from '../logoCreaterService/logoCreaterService.d';

export class logoCreatorMiddleware {
    private readonly scrollLock: ScrollLock;
    private readonly esAppHelper: EsAppHelper;
    private static _instance: logoCreatorMiddleware;
    private designerOverlay: DesignerOverlayModal;
    private ttcOverlay: TransforToCartOverlayModal;
    private basketService: BasketService;
    private confirmationModal: ConfirmationModal;
    private noAvailableSizeModal: NoAvailableSizeModal;
    private lcService: LogoCreaterService;
    private context: IContext;

    private masterArticleNo: number;
    private navKey: string;
    private navKeyPath: string;
    private userId: string;
    private withVat: boolean;
    private oneTimeToken: string;
    private preselectedArticles: Array<ISmakeArticle>;
    private alreadyAddToCart = false;
    private availableColors: Array<string>;
    private smakeCampaignEntry = 'smake_campaign_entry';
    private passThroughItemOrign: string;
    private designerItemOrigin = 'smake_designer';
    private vatRat: number;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public constructor() {
        this.context = window.__PP_LC_CONTEXT__;
        this.basketService = BasketService.instance;
        this.lcService = LogoCreaterService.instance;
        this.scrollLock = new ScrollLock();
        this.esAppHelper = new EsAppHelper();
        this.appShellEventBinding();
    }

    private appShellEventBinding(): void {
        // Open designer
        if (window && window.shell) {
            window.shell.subscribeTo('ESPP.LogoCreator.OpenDesignerWindow', (payload: IDesignerAppshellPayload) => {
                this.preselectedArticles = payload.preselectedArticles;
                this.masterArticleNo = payload.masterArticleNumber;
                this.navKey = payload.navKey;
                this.navKeyPath = payload.navKeyPath;
                this.withVat = payload.withVat;
                this.vatRat = this.withVat ? Number(this.context.vatRate) : 0;
                this.passThroughItemOrign = payload.itemOrigin;

                const [salesArticleNo, colorCode] = this.parseSavKey(payload.preselectedArticles[0].variant.external_identifier);
                const ott = this.lcService.getOneTimeToken();
                const colors = this.lcService.getAvailableColors(
                    this.masterArticleNo, salesArticleNo, colorCode, this.navKey,);
                const sizes = this.lcService.getAvailableSizes(
                    this.navKey, this.masterArticleNo, salesArticleNo, colorCode);
                const basket = this.getBasketItems();
                Promise.all([ott, colors, sizes, basket]).then(([ottResponse, colorSAVKeys, sizesSAVKeys, cartItems]) => {
                    if (ottResponse && colorSAVKeys && sizesSAVKeys) {
                        this.oneTimeToken = ottResponse.token_string;
                        this.userId = ottResponse.user_id;
                        this.preselectedArticles.map((smakeArticle) => {
                            const savKey = smakeArticle.variant.external_identifier;
                            smakeArticle.variant.external_identifier =
                                `${payload.masterArticleNumber.toString()}#${savKey}`;
                        });

                        let smakeId: number = null;
                        const articleHasId = this.preselectedArticles.find((smakeArticle) => {
                            return smakeArticle.variant.id;
                        })
                        if (articleHasId) {
                            smakeId = articleHasId.variant.id;
                        }

                        this.availableColors = colorSAVKeys.map(colorSAVkey =>
                            `${this.masterArticleNo}#${colorSAVkey.external_identifier}`);

                        const newSizesKeys = sizesSAVKeys.map(sizeSAVkey =>
                             `${this.masterArticleNo}#${sizeSAVkey.external_identifier}`);

                        if (this.designerOverlay) {
                            this.designerOverlay.update(
                                this.preselectedArticles[0].variant.external_identifier,
                                this.userId, this.oneTimeToken, this.vatRat, this.availableColors, newSizesKeys, cartItems, smakeId);
                        } else {
                            this.designerOverlay = new DesignerOverlayModal(
                                this.preselectedArticles[0].variant.external_identifier,
                                this.userId,
                                this.oneTimeToken,
                                this.vatRat,
                                this.availableColors,
                                newSizesKeys,
                                cartItems,
                                this.tryToCloseOverlay.bind(this),
                                smakeId);
                        }
                        this.showDesignerOverlayModal();
                    }
                });
            },
                'ESPP.LogoCreator.OpenDesignerWindow'
            );
            window.shell.publishTo('ESPP.LogoCreator.InitializationFinished', null);
        }
    }

    private showDesignerOverlayModal(): void {
        this.prepareToOpenModal();
        this.designerOverlay.showOverlayModal(this.oneTimeToken);

        // bind creation event
        const designerQuery = '#designer-strauss';
        const smake = document.querySelector(designerQuery);
        smake.addEventListener('custom-variant-created', (payload: CustomEvent) => {
            if (payload.type === 'custom-variant-created') {
                const designerResponse: ICreatVariantRespons = payload.detail[0];
                const smakeId = designerResponse.id;
                const idArray = designerResponse.base.external_identifier.split('#');
                const newMasterArticleNo = parseInt(idArray[0]);

                if (!isNaN(newMasterArticleNo)) {
                    if (this.masterArticleNo !== newMasterArticleNo) {
                        this.masterArticleNo = newMasterArticleNo;
                        this.navKey = null;
                    }
                }

                const [salesArticleNo, colorCode] = this.parseSavKey(idArray.pop());
                const basket = this.getBasketItems();
                const sizes = this.lcService.getAvailableSizes(
                    this.navKey, this.masterArticleNo, salesArticleNo, colorCode);
                const ottPromise = this.lcService.getOneTimeToken();

                Promise.all([basket, sizes, ottPromise]).then(([psArticles, sizesSAVKeys, ott]) => {
                    if (sizesSAVKeys && ott) {
                        this.preselectedArticles = this.parsePreselectedArticle(sizesSAVKeys, smakeId);
                        this.oneTimeToken = ott.token_string;
                        const newSizesKeys = sizesSAVKeys.map(sizeSAVkey =>
                            sizeSAVkey =
                            { external_identifier: `${this.masterArticleNo}#${sizeSAVkey.external_identifier}` });

                        if (this.ttcOverlay) {
                            this.ttcOverlay.update(smakeId,
                                psArticles, newSizesKeys,
                                this.preselectedArticles, this.userId, this.oneTimeToken, this.vatRat);
                        } else {
                            this.ttcOverlay = new TransforToCartOverlayModal(
                                smakeId,
                                psArticles,
                                newSizesKeys,
                                this.preselectedArticles,
                                this.userId,
                                this.oneTimeToken,
                                this.vatRat,
                                this.tryToCloseOverlay.bind(this));
                        }

                        this.designerOverlay.closeOverlayModal();
                        const sizesKeysForDesigner = newSizesKeys.map(sizeKey => sizeKey.external_identifier);
                        this.designerOverlay.update(
                            designerResponse.base.external_identifier,
                            this.userId, this.oneTimeToken, this.vatRat, this.availableColors, sizesKeysForDesigner, psArticles, smakeId);
                        this.ttcOverlay.showOverlayModal();
                        this.bindTTCEvent();
                    } else {
                        // show size modal:
                        if (!this.noAvailableSizeModal) {
                            this.noAvailableSizeModal = new NoAvailableSizeModal();
                        }
                        this.noAvailableSizeModal.showOverlayModal();
                    }
                });
            } else if (payload.type === 'error') {
                // error handling for smake error
            } else {
                // unknow error
            }
        });

        smake.addEventListener('session-expired', () => {
            this.lcService.getOneTimeToken().then((ottResponse) => {
                if (ottResponse) {
                    this.oneTimeToken = ottResponse.token_string;
                    smake.setAttribute('token', this.oneTimeToken);
                }
            })
        });

        smake.addEventListener('add-collection-items-to-cart', (payload: CustomEvent) => {
            if (payload.type === 'add-collection-items-to-cart') {
                const designerResponse: Array<AddCollectionItemsToCartResponse> = payload.detail[0];
                this.addArticleForTeamDesigner(designerResponse);
            }
        });

        smake.addEventListener('variant-base-changed', (payload: CustomEvent) => {
            const articleID = payload.detail[0]?.external_identifier;
            if (articleID) {
                const [masterArticleNumber, savKey] = articleID.includes("#")
                    ? (articleID.split("#") as [string, string])
                    : [null, null];
                const masterArticleNo = parseInt(masterArticleNumber);
                if (!Number.isNaN(masterArticleNo) && savKey) {
                    const [salesArticleNo, colorCode] = this.parseSavKey(savKey);
                    let colorsPromis = null;
                    const sizesPromis = this.lcService.getAvailableSizes(this.navKey, masterArticleNo, salesArticleNo, colorCode);
                    if (parseInt(masterArticleNumber) != this.masterArticleNo) {
                        colorsPromis = this.lcService.getAvailableColors(masterArticleNo, salesArticleNo, colorCode, this.navKey);
                    }
                    Promise.all([colorsPromis, sizesPromis]).then(([colors, sizes]) => {
                        let newColorsKeys = null;
                        if (colors) {
                            newColorsKeys = colors.map(colorSAVkey =>
                                `${this.masterArticleNo}#${colorSAVkey.external_identifier}`);
                            this.availableColors = newColorsKeys;
                        }
                        if (sizes) {
                            const newSizesKeys = sizes.map(sizeSAVkey =>
                                `${this.masterArticleNo}#${sizeSAVkey.external_identifier}`);
                            this.designerOverlay.updateDesigner(newColorsKeys, newSizesKeys);
                        }
                    });
                }
            }
        });

        if (this.context.enablePiwik && 'dataLayer' in window) {
            smake.addEventListener('search-statistics', (payload: CustomEvent) => {
                const [{
                    category_names,
                    production_method_handle: production_method,
                    query,
                    result_count }] = payload.detail;

                const searchstatistics = {
                    category_names,
                    production_method,
                    query,
                    result_count
                };
                // TODO: gotta send this to _paq
                const piwikPayload = {
                    event: 'smakesearchstatistics',
                    searchstatistics
                }
                if ('dataLayer' in window) {
                    const dl = (window.dataLayer || []) as Array<unknown>;
                    dl.push(piwikPayload);
                }
            })
        }
    }

    private parseSavKey(savKey: string): [string, number] {
        const savKeyStrings = savKey.split('-');
        const salesArticleNo = savKeyStrings[0];
        const colorCode = parseInt(savKeyStrings[1]);
        return [salesArticleNo, colorCode];
    }

    private parsePreselectedArticle(newSizesKeys: ISmakevailableVariant[], smakeId: number): Array<ISmakeArticle> {
        const masterArticleNoString = this.preselectedArticles[0].variant.external_identifier.split('#')[0];
        const masterArticleNo = parseInt(masterArticleNoString);
        const id = this.preselectedArticles[0].variant.id;

        if (id !== smakeId) {
            this.preselectedArticles.map((article) => {
                article.variant.id = smakeId;
            });
        }

        if (masterArticleNo === this.masterArticleNo) {
            return this.preselectedArticles;
        } else {
            const newReturn: Array<ISmakeArticle> = [];
            this.preselectedArticles.forEach((article) => {
                const oldSavKey = article.variant.external_identifier.split('#')[1];
                const sizeCode = oldSavKey.split('-')[2];
                const matchedSize = newSizesKeys.find((size) => {
                    const newsizeCode = size.external_identifier.split('-')[2];
                    return newsizeCode === sizeCode;
                });
                if (matchedSize) {
                    newReturn.push(article);
                }
            });
            return newReturn;
        }
    }

    private bindTTCEvent() {
        const ttc = document.querySelector(`#${this.ttcOverlay.ttcId}`);
        ttc.addEventListener('add-to-cart', (payload: CustomEvent) => {
            const ttcResponse: ITTCObject = payload.detail[0];
            const variants: Array<IVariant> = [];
            let itemOrigin = this.getItemOrigin();

            const basketModalpayload: IBasketModalPayload = {
                smakeId: this.ttcOverlay.smakeId,
                articles: [],
                masterArticleNumber: this.masterArticleNo,
                reporting: ttcResponse.reporting,
                itemOrigin: itemOrigin,
            };
            ttcResponse.cart_items.map((smakeArticle) => {
                const savKey = smakeArticle.variant.external_identifier.split('#').pop();
                const variant = {
                    salesArticleVariantKey: savKey,
                    quantity: smakeArticle.quantity,
                    itemOrigin: itemOrigin,
                    nativeNavKeyPath: this.navKeyPath,
                }
                const basketmodal = {
                    savKey: savKey,
                    quantity: smakeArticle.quantity
                }
                variants.push(variant);
                basketModalpayload.articles.push(basketmodal);
            });

            if (this.context.isBasketPage) {
                if (window && window.shell) {
                    if (!this.alreadyAddToCart) {
                        this.alreadyAddToCart = true;
                        window.shell.publishTo('ESPP.LogoCreator.FinishedDesign', {
                            smakeVariantId: ttcResponse.variant.id,
                            variants
                        });
                        window.shell.subscribeTo('ESSA.LogoCreator.CloseDesigner', () => {
                            this.ttcOverlay.closeOverlayModal();
                            this.afterCloseOverlay();
                            this.alreadyAddToCart = false;
                        }, 'ESPP.LogoCreator.Designer');
                    }
                } else {
                    this.ttcOverlay.closeOverlayModal();
                    this.afterCloseOverlay();
                }
            } else {

                this.basketService.postArticles(ttcResponse.variant.id, variants).then(() => {
                    const smakeCampaignEntry = window.sessionStorage.getItem(this.smakeCampaignEntry);
                    if (smakeCampaignEntry) {
                        window.sessionStorage.removeItem(this.smakeCampaignEntry);
                    }
                    this.ttcOverlay.closeOverlayModal();
                    if (window && window.shell) {
                        // update basket flyout
                        window.shell.publishTo('ESSA.BasketFlyout.BasketItemCountChanged', null);
                        // tell PDP to show basketModal
                        window.shell.publishTo('ESPP.LogoCreator.DidAddToBasket', basketModalpayload);
                    }
                    this.afterCloseOverlay();
                });
            }
        });

        // bind creation event
        ttc.addEventListener('abort', (payload: CustomEvent) => {
            if (payload.type === 'abort') {
                this.lcService.getOneTimeToken().then((ottResponse) => {
                    if (ottResponse) {
                        this.oneTimeToken = ottResponse.token_string;
                    }
                    this.ttcOverlay.closeOverlayModal();
                    this.showDesignerOverlayModal();
                });
            } else if (payload.type === 'error') {
                // error handling for smake error
            } else {
                // unknow error
            }
        });

        // bind session expired
        ttc.addEventListener('session-expired', () => {
            this.lcService.getOneTimeToken().then((ottResponse) => {
                if (ottResponse) {
                    this.oneTimeToken = ottResponse.token_string;
                    ttc.setAttribute('token', this.oneTimeToken);
                }
            })
        });
    }

    private addArticleForTeamDesigner(payload: Array<AddCollectionItemsToCartResponse>): void {
        let itemOrigin = this.getItemOrigin();
        const variantsPayload: Array<IVariantArticles> = payload.map((response) => ({
            smakeVariantId: response.variant.id,
            variants: response.quantities.map((quantity) => ({
                salesArticleVariantKey: quantity.variant.externalIdentifier.split('#').pop(),
                quantity: quantity.quantity,
                itemOrigin: itemOrigin,
                nativeNavKeyPath: this.navKeyPath,
            })),
        }));
        if (this.context.isBasketPage) {
            if (window && window.shell) {
                if (!this.alreadyAddToCart) {
                    this.alreadyAddToCart = true;
                    window.shell.publishTo('ESPP.LogoCreator.TeamDesignerFinishedDesign', variantsPayload);
                    // close designer after add to basket
                    window.shell.subscribeTo('ESSA.LogoCreator.CloseDesigner', () => {
                        this.designerOverlay.closeOverlayModal();
                        this.afterCloseOverlay();
                        this.alreadyAddToCart = false;
                    }, 'ESPP.LogoCreator.Designer');
                }
            } else {
                this.designerOverlay.closeOverlayModal();
                this.afterCloseOverlay();
            }
        } else {
            const teamDesignerPayload = variantsPayload.map((item) => ({
                smakeVariantId: item.smakeVariantId,
                sizeVariants: item.variants.map((variant) => ({
                    salesArticleVariantKey: variant.salesArticleVariantKey,
                    quantity: variant.quantity,
                    itemOrigin: variant.itemOrigin,
                    nativeNavKeyPath: variant.nativeNavKeyPath,
                })),
            }));
            const result = this.basketService.postArticlesForTeamDesigner(teamDesignerPayload).then(() => {
                const smakeCampaignEntry = window.sessionStorage.getItem(this.smakeCampaignEntry);
                if (smakeCampaignEntry) {
                    window.sessionStorage.removeItem(this.smakeCampaignEntry);
                }

                const reportings: Array<ITeamDesignerReporting> = payload.map((item) => {
                    const teamModeCustomization = item.reporting.customizations
                        .split(',').map((s) => s.trim()).filter(Boolean)
                        .map((s) => s + '_Teammode').join(', ');
                    // ideally only have one element inside quantities array. if more that that, there is problem
                    const quantity = item.quantities[0].quantity;
                    const pricePerArticleValue: number = quantity !== 0 ? Number((item.reporting.price.value / quantity).toFixed(2)) : 0;
                    return {
                        savKey: item.quantities[0].variant.externalIdentifier.split('#').pop(),
                        customizations: teamModeCustomization,
                        price: {
                            value: pricePerArticleValue,
                            currency: item.reporting.price.currency,
                        }
                    }
                });

                const basketModalpayload: IBasketModalPayload = {
                    smakeId: variantsPayload[0].smakeVariantId,
                    articles: variantsPayload.reduce(
                        (acc, article) => [
                            ...acc,
                            ...article.variants.map(variant => ({
                                savKey: variant.salesArticleVariantKey,
                                quantity: variant.quantity,
                            })),
                        ],
                        [] as Array<{ savKey: string; quantity: number }>
                    ),
                    masterArticleNumber: this.masterArticleNo,
                    reporting: null, // null for team mode, use reportings field
                    reportings: reportings,
                    itemOrigin: itemOrigin,
                };

                this.designerOverlay.closeOverlayModal();
                if (window && window.shell) {
                    // update basket flyout
                    window.shell.publishTo('ESSA.BasketFlyout.BasketItemCountChanged', null);
                    // tell PDP to show basketModal
                    window.shell.publishTo('ESPP.LogoCreator.DidAddToBasket', basketModalpayload);
                }
                this.afterCloseOverlay();
            });
        }
    }

    private getItemOrigin(): string {
        let itemOrigin: string;

        if (this.passThroughItemOrign && this.passThroughItemOrign.length > 0) {
            itemOrigin = this.passThroughItemOrign;
        } else {
            itemOrigin = this.designerItemOrigin;
            const smakeCampaignEntry = window.sessionStorage.getItem(this.smakeCampaignEntry);
            if (smakeCampaignEntry) {
                itemOrigin += `/${smakeCampaignEntry}`;
            }
        }
        return itemOrigin;
    }

    private afterCloseOverlay(): void {
        // unlock the screen:
        this.scrollLock.unlock();

        //show esApp navigation wheel
        this.esAppHelper.navigationWheel.show();

        // restore babbleBubble
        if (window.shell)
            window.shell.publishTo('esmkt.babblebubble.restore', null);
    }

    private tryToCloseOverlay(callBack: () => void): void {
        if (this.confirmationModal) {
            this.confirmationModal.update(callBack, this.afterCloseOverlay.bind(this));
        } else {
            this.confirmationModal = new ConfirmationModal(callBack, this.afterCloseOverlay.bind(this));
        }
        this.confirmationModal.showOverlayModal();
    }

    private getBasketItems(): Promise<ISmakeArticle[]> {
        return this.basketService.getArticles().then((data: IBasketItems) => {
            const smakeArticles: ISmakeArticle[] = [];

            if (data && data.articles.length > 0) {
                data.articles.map((article) => {
                    smakeArticles.push({
                        quantity: article.quantity,
                        variant: {
                            id: article.smakeVariantId,
                            external_identifier: article.masterArticleNo + '#' + article.salesArticleVariantKey
                        }
                    })
                });
            }

            return smakeArticles;
        });
    }

    private prepareToOpenModal() {
        // lock screen:
        this.scrollLock.lock();

        //hide esApp navigation wheel
        this.esAppHelper.navigationWheel.hide();

        // pop babblebubble
        setTimeout(() => {
            if (window.shell)
                window.shell.publishTo('esmkt.babblebubble.setlayer', 1051);
        }, 1500);
    }
}

logoCreatorMiddleware.instance;
